import { useNavigate } from "react-router-dom";
import AuthLayout from "./layout";
import LoginForm from "@components/auth/login-form";

const LoginPage = () => {
  return (
    <AuthLayout>
      <LoginForm />
    </AuthLayout>
  );
};

export default LoginPage;
